import { MobXProviderContext } from 'mobx-react';
import ConversationModel from 'Models/ConversationModel';
import * as React from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { isNullOrUndefined } from 'util';

/**
 * @description Checks if the other participant in a one-on-one conversation is inactive
 * @param conversation - The conversation to check
 * @returns True if the other participant is inactive, false otherwise
 */
export const useIsPersonInactive = (conversation: ConversationModel) => {
  const { person: personStore } =
    React.useContext<RootStoreProps>(MobXProviderContext);

  const [isInactive, setIsInactive] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (conversation?.grouping === 'OneOnOne') {
      const otherParticipant = conversation?.participants.find(
        ({ personId }) => personId !== personStore.loggedInPersonId
      );

      // If we have another participant, and it's a person, we can check if they are inactive
      if (otherParticipant?.personId) {
        const otherParticipantContactPbo =
          personStore.loadPersonByIdGetIfMissingGet(
            otherParticipant.personId.toString()
          );

        if (!isNullOrUndefined(otherParticipantContactPbo)) {
          void otherParticipantContactPbo.then((response) => {
            response && setIsInactive(response.deleted);
          });
        }
      }
    }
  }, [conversation, personStore]);

  return isInactive;
};
